<template>
  <!-- 通话中不予关闭 -->
  <Modal
    :closable="statusCode == null || [-1, 0, 1, 2, 3, 4, 6, 8].indexOf(this.statusCode) >=0 "
    :styles="{top: '50px', width: 'max-content', maxWidth: '90vw'}"
    @on-cancel="cancelPanel"
    class-name="hlModal"
    footer-hide
    title="话务工作台"
    v-model="showPanel"
  >
    <HLDetail
      :currentId="currentLedgerId"
      :edit="true"
      @cancelLedger="cancelLedger"
      ref="workbenchDetail"
    >
      <template slot="extLeft">
        <div class="workbenchTool mb1" id="workbenchTool"></div>
      </template>
    </HLDetail>
    <Spin fix v-if="spinShow">
      <Icon class="demo-spin-icon-load" size="18" type="ios-loading"></Icon>
      <div>操作中，请稍候...</div>
    </Spin>
  </Modal>
</template>
<script>
import utils from "@/libs/utils"
import HLDetail from '@/views/systemManage/ICHL/HLDetail.vue'
export default {
  name: 'workBench',
  components: {
    HLDetail
  },
  props: {
    status: {
      required: true,
      default: false,
    },
    show: {
      required: true,
      default: false,
    },
    opts: {
      required: true,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      currentWorkMode: '',
      currentLedgerId: null,
      satisfactionResultOptions: [],
      satisfactionResultMap: {},
      toolType: 'personInfo',
      statusCode: null,
      eventTags: [],
      spinShow: false,
      showPanel: false,
      // 当前选择的通话记录
      clickRow: null,
      activeConfig: {},
      ledgerForm: {},
      consultantInfo: null,
      currentCallRecord: null,
      currentUser: null,
      conversationInfos: [],
      keywords: [],
      loadingConversation: false,
      tagList: [],
      defaultTagList: [],
      callTypeOptions: [],
      ledgerFormValidate: {
        mainBussinessTypeId: [{ required: true, message: '请选择主业务类型', trigger: "change" }],
        clientDescription: [{ required: true, message: '请输入客户自述内容', trigger: "blur" }],
        lawyerSuggestion: [{ required: true, message: '请输入处理意见', trigger: "blur" }],
        leAges: [{ required: true, message: '请选择年龄段', trigger: "change" }],
        leGender: [{ required: true, message: '请选择性别', trigger: "change" }],
        leProfession: [{ required: true, message: '请选择职业', trigger: "change" }],
        leConsultationType: [{ required: true, message: '请选择客户类别', trigger: "change" }],
        leEducational: [{ required: true, message: '请选择学历', trigger: "change" }],
        name: [{ required: true, message: '请填写咨询人姓名', trigger: 'blur' }],
      },
      timerMessage: null,
      loadingPortrait: false,
      currentPhone: null
    }
  },
  computed: {
    isEdit: function () {
      return this.ledgerForm?.consultationStatus == 'wait'
    },
    baseURL: function () {
      return this.$store.getters['systemSupport/systemSupport']?.HL || process.env.VUE_APP_API_ROOT
    },
    hlLawyerStatus: function () {
      let status = this.$store.getters['lawyerInfo/lawyerStatus']['HL_FP']

      return status
    },
  },
  watch: {
    // 'status': {
    //   deep: true,
    //   handler: function (val) {
    //     switch (this.activeConfig.serviceCode) {
    //       case 'aliyun':
    //         if (val) {
    //           try {
    //             if (window.workbench) {

    //               window.workbench.register()
    //             } else {

    //             }

    //           } catch (e) {
    //             console.log('register error', e)
    //           }

    //         } else {
    //           try {
    //             window.workbench.logOut()
    //           } catch (e) {
    //             console.log('logOut error', e)
    //           }
    //         }
    //         break
    //     }
    //   }
    // },
    'show': {
      deep: true,
      handler: function (val) {
        this.showPanel = val
        switch (this.activeConfig.serviceCode) {
          case 'aliyun':
            if (window.workbench) {
              window.workbench.changeUIConfig({ mainContentVisible: val })
            } else if (this.showPanel) {
              this.iniAli(true)
            }
            break
        }
      }
    }
  },
  methods: {
    logIn: function () {
      console.log('ali register')
      if (window.workbench) {

        window.workbench.register()
      } else {
        this.iniAli(true)
      }
    },
    cancelLedger: function () {
      this.currentLedgerId = null
    },
    cancelPanel: function () {
      this.clickRow = null
      this.currentCallRecord = null
      this.ledgerForm = {}
      this.$emit('changeVisible', false)
    },
    getActiveConfig: function () {
      let that = this
      this.$axios.post(that.$apis.HLConfigApi.base.getActiveConfig, null, {
        baseURL: this.baseURL
      }).then(res => {
        if (res.success) {
          that.activeConfig = res.result || {}
          that.initWorkbench()
        } else {
          that.$Message.error(res.message || "获取话务配置失败！")
        }
      }).catch(function (err) {
        that.$Message.error("获取话务配置失败！")
      })
    },
    initWorkbench: function () {
      console.log('当前初始化服务商编码', this.opts.serviceCode)
      switch (this.opts.serviceCode) {
        case 'aliyun':
          this.iniAli(this.status)
          break

      }
    },
    iniAli: function (init) {
      // https://help.aliyun.com/zh/ccs/use-cases/ccc-sdk-frontend-access-3?spm=a2c4g.11186623.help-menu-59499.d_3_0_2.6890461aHPU4m6&scm=20140722.H_2716486._.OR_help-T_cn~zh-V_1#title-79v-fov-2gl
      let that = this
      try {
        if (window.workbench) {
          // 不重复初始化
          window.workbench.unloadWorkbench()
          window.workbench = null
          // return
        }
        const config = {
          dom: 'workbenchTool',
          regionId: 'cn-shanghai',
          instanceId: this.opts.appId,
          ajaxPath: this.baseURL + this.$apis.HLConfigApi.aliyunConfig.callApi,
          ajaxMethod: 'post',
          withCredentials: true,
          ajaxHeaders: {
            Authorization: utils.getToken()
          },
          header: false,
          logger: {
            builtinEnabled: true,
            level: 1, //日志等级，0(error)，1(warn)，2(log)，3(debug)
          },
          afterCallRule: 60,  // 挂机后的话后处理时间
          header: true,
          width: 300,
          height: 360,
          visible: true,// 是否展示SDK面板
          exportErrorOfApi: true,
          mainContentVisible: true, // 是否展示SDK面板完整内容，设置false则只展示最简单功能的SDK工具条
          pollFrequenceWithoutWS: 3000, //当坐席状态WebSocket连接失败时，调用Rest API来拉取坐席状态的频率。
          pollFrequenceWithWS: 3000,//当坐席状态WebSocket连接成功时，调用Rest API来拉取坐席状态的频率。
          //是否允许使用多标签页外呼 首先所有标签页都要在一个浏览器中，要求只有一个标签页注册WorkbenchSdk，并保持该标签页的登录状态。
          // https://help.aliyun.com/zh/ccs/use-cases/sdk-frontend-access?spm=5176.9047633.help.dexternal.34f63b19USTQFe#section-n8i-hyo-vkx
          // useLocalStorageToCall: true,
          // moreActionList: ["online", "ready", "onlyCall", "break", "offline", "adjustVolume", "changeWorkMode"], //分别对应[上线, 结束小休, 隐身, 小休, 下线, 调节音量, 场外模式接听]
          // 技能组组长及管理员能 '监听'
          // '内部通话', 
          // sideNavList: ['呼入', '呼出', '通话记录', '转接', '我的工作', '监听', '设备检测', '设置'],
          functionSwitch: {
            showFlashSmsConfig: false, //显示右上角设置中【闪信配置】操作，当前配置生效的前提是配置过闪信运营商
            closeable: false,
            allowStartConference: false, //允许坐席发起会议
            invisibilityAction: false, //显示左上角状态切换里的【隐身】操作
            allowMonitoring: false, //此选项开启以后还需要管理员或者技能组组长权限，坐席权限就算设置此项也不能发起监听
            allowCreateTicket: false, //允许坐席创建工单
            allowCreateSessionSummary: false, //允许坐席会话小结
          },
          onInit: function () {
            console.log('onInit')
            // 想实现自动上线在此注册
            if (init) {
              window.workbench.register()
            }
            // if (process.env.NODE_ENV == 'development') {
            //   window.workbench.register()
            // } else {
            // TODO 此处考虑后期当前账号是否在值班时间然后做处理
            // if (that.hlLawyerStatus) {
            //   window.workbench.register()

            // } else {
            //   that.$Modal.confirm({
            //     title: '提醒',
            //     content: '<p>请确认是否上线话务工作台？</p><p>若不上线，稍候可在话务面板中手动上线</p>',
            //     okText: '上线',
            //     cancelText: '稍后处理',
            //     onOk: () => {
            //       window.workbench.register()
            //     }
            //   })
            // }
            // }
          },
          onRegister (config) {
            console.log('onRegister', config)
            that.currentUser = {
              userId: config.userId,
              extension: config.extension,
              isSIPMLOnLine: config.isSIPMLOnLine,
              isSipPhoneOnLine: config.isSipPhoneOnLine,
              workMode: config.workMode
            }
          },
          onLogIn () {
            console.log('上线成功')
            // window.workbench.changeMainPaneVisible(true)
            window.workbench.changeUIConfig({ mainContentVisible: true })
            that.$emit('changeVisible', true)
          },
          onLogOut () {
            //签出、下线时触发
            console.log('下线啦')
            // that.$emit('changeVisible', true)
          },
          onBreak: function (data) {
            //小休时触发
            console.log('onBreak', data)
            console.log('休息啦')
          },
          onWorkModeChange: function (workMode) {
            console.log('workModeChange', workMode)
          },
          // 这里有很多方法，需要可配，不需要就不用配
          onErrorNotify: function (error) {
            console.log('onErrorNotify', error)
          },
          onReady () {
            console.log('onReady')
          },
          onCallComing: function (callDetail) {
            // 来电时触发，可以在该函数内获取到一个对象callDetail，callDetail参数信息含义如下：

            // caller：主叫号码
            // callee：被叫号码
            // callType：呼叫类型
            // jobId：当前通话的ID
            // callContext：当前通话的详细信息

            // 注意：为了提高接通率，当有来电振铃30s后未接听，会自动将当前坐席置为小休状态。
            // 电话自动流转回转人工队列，分配给其他空闲坐席。
            console.log("onCallComing", callDetail)
            that.currentPhone = callDetail.caller
            that.pushCallRecord({
              appId: callDetail.instanceId || that.opts.appId,
              serialNum: callDetail.jobId,
              callType: callDetail.callType,
              caller: callDetail.caller,
              callee: callDetail.callee
            })
            // {
            //   "caller": "02566823517",
            //     "callee": "6690256682351701",
            //       "callType": "INBOUND",
            //         "jobId": "job-6c8aa508-4aa1-417a-af4e-9a16841f4b5f",
            //           "callContext": {
            //     "callType": "INBOUND",
            //       "channelContexts": [
            //         {
            //           "callType": "INBOUND",
            //           "channelFlags": "[]",
            //           "channelId": "aa9f64da-0143-11ef-9010-9d991feb8c3d",
            //           "channelState": "ANSWERED",
            //           "channelVariables": "",
            //           "destination": "6690256682351701",
            //           "earlyMediaTime": 0,
            //           "index": 1,
            //           "jobId": "job-6c8aa508-4aa1-417a-af4e-9a16841f4b5f",
            //           "mediaType": "AUDIO",
            //           "originator": "02566823517",
            //           "stampedChannelFlags": {},
            //           "timestamp": 1713857565206,
            //           "userChannel": false,
            //           "userDestination": false,
            //           "userOriginator": false
            //         },
            //         {
            //           "callType": "INBOUND",
            //           "channelFlags": "[]",
            //           "channelId": "ch-user-02566823517-80507288-1713857565260-job-6c8aa508-4aa1-417a-af4e-9a16841f4b5f",
            //           "channelState": "RINGING",
            //           "channelVariables": "",
            //           "destination": "80507288",
            //           "earlyMediaTime": 0,
            //           "index": 2,
            //           "jobId": "job-6c8aa508-4aa1-417a-af4e-9a16841f4b5f",
            //           "mediaType": "AUDIO",
            //           "originator": "02566823517",
            //           "skillGroupId": "skg-default@demo-1561665198599028",
            //           "stampedChannelFlags": {},
            //           "timestamp": 1713857565431,
            //           "userChannel": true,
            //           "userDestination": true,
            //           "userExtension": "80507288",
            //           "userId": "aliyun7661360911@demo-1561665198599028",
            //           "userOriginator": false
            //         }
            //       ],
            //         "instanceId": "demo-1561665198599028",
            //           "jobId": "job-6c8aa508-4aa1-417a-af4e-9a16841f4b5f"
            //   }
            // }
            that.$emit('onCallComing', callDetail)
          },
          onBeforeCallDialing: function (playload) {
            playload.callback()
          },
          onCallDialing: function (callDetail) {
            console.log('------//去电、拨号振铃时触发------')
            // 这边区分下 内部电话 内部通话的通话记录由接收方发起
            console.log('onCallDialing', callDetail)
            that.clickRow = null
            that.currentCallRecord = null
            that.ledgerForm = {}
            // 创建通话记录
            if (callDetail.callType == 'OUTBOUND') {
              // 呼出
              that.currentPhone = callDetail.callee
            } else {
              that.currentPhone = callDetail.calleer
            }
            that.pushCallRecord({
              appId: callDetail.instanceId || that.opts.appId,
              serialNum: callDetail.jobId,
              callType: callDetail.callType,
              caller: callDetail.caller,
              callee: callDetail.callee
            })

            // //INTERNAL 内部通话
            // if (callDetail.callType != 'INTERNAL') {
            //   that.currentPhone = callDetail.callee
            //   that.pushCallRecord({
            //     appId: callDetail.instanceId || that.opts.appId,
            //     serialNum: callDetail.jobId,
            //     callType: callDetail.callType,
            //     caller: callDetail.caller,
            //     callee: callDetail.callee
            //   })
            // }
          },
          onSelectCurrentCallRecord: function ({ record }) {
            console.log('onSelectCurrentCallRecord', record)
            console.log('onSelectCurrentCallRecord statusCode', that.statusCode)
            console.log('onSelectCurrentCallRecord clickRow', that.clickRow)
            // 选中聊天记录触发 3空闲
            if ([3].indexOf(that.statusCode) >= 0) {
              if (that.currentLedgerId && record.contactId != that.currentCallRecord?.serialNum) {
                that.$Modal.confirm({
                  title: '提醒',
                  content: '查看历史通话内容前，请确认当前表单内容是否已经保存！',
                  okText: '继续',
                  onOk: () => {
                    that.clickRow = record
                    that.loadCallRecord(record.instanceId, record.contactId)
                  }
                })
              } else {
                that.clickRow = record
                that.loadCallRecord(record.instanceId, record.contactId)
              }
            } else {
              // 内部通话不会出现在通话记录中
              that.$Message.warning({ content: '当前状态不予操作通话记录！', duration: 3 })
            }
          },
          onStatusChange: function (codeDetail) {
            // 任何状态改变都会触发该函数，可在该函数内监听当前状态值的变化过程，状态code的含义请参考本文档第八条状态对照表。
            // https://help.aliyun.com/zh/ccs/use-cases/sdk-frontend-access?spm=5176.9047633.help.dexternal.34f63b19USTQFe#section-hkz-ce9-6rv

            // code: 当前状态码
            // lastCode： 上次状态码
            // context：上下文信息
            console.log('onStatusChange', codeDetail)
            that.statusCode = codeDetail?.code
            that.statusChangeHandle(codeDetail?.context)
            that.$emit('onStatusChange', codeDetail)
          },
          onCallEstablish: function ({ callContext }) {
            console.log('onCallEstablish', callContext)
            // if (callContext?.caller != that.currentUser.extension) {
            that.clickRow = callContext
            // 呼入呼出加载台账信息
            if (['INBOUND', 'OUTBOUND'].indexOf(callContext.callType)) {
              that.loadCallRecord(callContext?.instanceId || that.opts.appId, callContext?.jobId)
              // that.currentPhone = callContext?.caller
              // switch (callContext?.callType) {
              //   case 'OUTBOUND':
              //     that.currentPhone = callContext?.callee
              //     break
              // }
              // that.getPortrait(that.currentPhone)
              // that.popLedger({
              //   icSubType: 'HL_FP',
              //   appId: callContext?.instanceId || that.opts.appId,
              //   hlSerial: callContext?.jobId,
              //   consultationStatus: 'wait',
              //   callType: callContext?.callType,
              //   phoneNumber: that.currentPhone,
              //   dataSource: that.currentPhone
              // })
              //5秒执行一次获取接口
              // that.timerMessage = setInterval(() => {
              //   that.callConversationInfo()
              // }, 5000)
            }
            that.updateCallRecord(callContext?.instanceId || that.opts.appId, callContext?.jobId, 'establish')
            // }
          },
          onCallRelease: function ({ callContext }) {
            //通话结束时触发，可以在该函数内获取到一个对象callDetail，callDetail参数信息含义如下：
            console.log('onCallRelease', callContext)
            that.$emit('onCallRelease', callContext)
            if (callContext.channelContexts && callContext.channelContexts.length > 0) {
              let callType = callContext.channelContexts[callContext.channelContexts.length - 1].callType
              let channelState = callContext.channelContexts[callContext.channelContexts.length - 1].channelState
              //话务通道的被叫方。
              let destination = callContext.channelContexts[callContext.channelContexts.length - 1].destination
              switch (callType) {
                case 'INTERCEPT':
                  //  强拆 表示话务被转走了
                  that.clickRow = null
                  that.currentCallRecord = null
                  that.ledgerForm = {}
                  that.$Message.warning({
                    content: '当前通话已被转出！',
                    duration: 3
                  })
                  break
                default:
                  if (channelState == 'NONE' && destination != that.currentUser.extension) {
                    that.clickRow = null
                    that.currentCallRecord = null
                    that.ledgerForm = {}
                    that.$Message.warning({
                      content: '当前通话已被转接处理！',
                      duration: 3
                    })
                  } else {
                    that.updateCallRecord(callContext?.instanceId || that.opts.appId, callContext?.jobId, 'release')
                  }
                  break
              }

            } else {
              that.updateCallRecord(callContext?.instanceId || that.opts.appId, callContext?.jobId, 'release')
            }
            if (that.timerMessage) clearInterval(that.timerMessage)
            that.timerMessage = null
          },
          onHangUp (type) {
            //挂断电话
            console.log('onHangUp', type)
            that.hangUpRecord(type)
          },
          onWorkModeChange (workMode) {
            console.log('onWorkModeChange', workMode)
            that.currentWorkMode = workMode
          },
          onSignedSkillGroupChange (signedSkillGroupList) {
            console.log('onSignedSkillGroupChange', signedSkillGroupList)
          },
          onBeingMonitored (event) {
            console.log('onBeingMonitored', event)
          },
        }

        // if (window.workbench) {
        window.workbench = new window.CCCWorkbenchSDK(config)
        console.log('config', config)
        // } else {
        // console.log('workbench reRender')
        // window.workbench.reRender()
        // }
      } catch (err) {
        console.error('WorkbenchSdk fail', err)
      }
    },
    logOut: function () {
      // 场内模式）：通过浏览器接听、拨打电话
      // 小休 	空闲 仅外呼 话后处理
      if (window.workbench && [2, 3, 4, 5].indexOf(this.statusCode) >= 0 && this.currentWorkMode == 'ON_SITE') {
        window.workbench.logOut()
      }
    },
    //状态改变事件
    statusChangeHandle: function (detail) {
      // {
      //   "callContext": {
      //     "callType": "INBOUND",
      //       "channelContexts": [
      //         {
      //           "callType": "INBOUND",
      //           "channelFlags": "[]",
      //           "channelId": "1c7ee28c-0500-11ef-b686-b731e7b90669",
      //           "channelState": "ANSWERED",
      //           "channelVariables": "",
      //           "destination": "6690228194434801",
      //           "earlyMediaTime": 0,
      //           "index": 1,
      //           "jobId": "job-cff9ff67-9574-44fc-b469-561824368c8b",
      //           "mediaType": "AUDIO",
      //           "originator": "02281944348",
      //           "stampedChannelFlags": {},
      //           "timestamp": 1714268355029,
      //           "userChannel": false,
      //           "userDestination": false,
      //           "userOriginator": false
      //         },
      //         {
      //           "callType": "INBOUND",
      //           "channelFlags": "[MONITORED]",
      //           "channelId": "ch-user-02281944348-80507066-1714268385283-job-cff9ff67-9574-44fc-b469-561824368c8b",
      //           "channelState": "ANSWERED",
      //           "channelVariables": "",
      //           "destination": "80507066",
      //           "earlyMediaTime": 0,
      //           "index": 3,
      //           "jobId": "job-cff9ff67-9574-44fc-b469-561824368c8b",
      //           "mediaType": "AUDIO",
      //           "originator": "02281944348",
      //           "skillGroupId": "skg-default@demo-1948805356977487",
      //           "stampedChannelFlags": {
      //             "MONITORED": 1714268422199
      //           },
      //           "timestamp": 1714268422275,
      //           "userChannel": true,
      //           "userDestination": true,
      //           "userExtension": "80507066",
      //           "userId": "AAAA@demo-1948805356977487",
      //           "userOriginator": false
      //         },
      //         {
      //           "callType": "MONITOR",
      //           "channelFlags": "[MONITORING]",
      //           "channelId": "ch-user-80507066-80507050-1714268421974-job-cff9ff67-9574-44fc-b469-561824368c8b",
      //           "channelState": "ANSWERED",
      //           "destination": "80507050",
      //           "earlyMediaTime": 0,
      //           "index": 4,
      //           "jobId": "job-cff9ff67-9574-44fc-b469-561824368c8b",
      //           "mediaType": "AUDIO",
      //           "originator": "80507066",
      //           "stampedChannelFlags": {
      //             "MONITORING": 1714268422199
      //           },
      //           "timestamp": 1714268422255,
      //           "userChannel": true,
      //           "userDestination": true,
      //           "userExtension": "80507050",
      //           "userId": "332518358@qq.com@demo-1948805356977487",
      //           "userOriginator": false
      //         }
      //       ],
      //         "instanceId": "demo-1948805356977487",
      //           "jobId": "job-cff9ff67-9574-44fc-b469-561824368c8b"
      //   },
      //   "contextId": 466,
      //     "userContext": {
      //     "breakCode": "Warm-up",
      //       "deviceId": "CCC-192.168.31.130-chrome124-bs0aad18f2259e809",
      //         "extension": "80507050",
      //           "heartbeat": 1714268422254,
      //             "instanceId": "demo-1948805356977487",
      //               "jobId": "job-cff9ff67-9574-44fc-b469-561824368c8b",
      //                 "mobile": "13900000001",
      //                   "outboundScenario": false,
      //                     "reserved": 1714268421969,
      //                       "reservedTime": 1714268421969,
      //                         "signedSkillGroupIdList": [
      //                           "skg-default@demo-1948805356977487"
      //                         ],
      //                           "userId": "332518358@qq.com@demo-1948805356977487",
      //                             "userState": "TALKING",
      //                               "userStateTime": 1714268422254,
      //                                 "waitingForBreak": false,
      //                                   "waitingForBreakTime": 0,
      //                                     "workMode": "ON_SITE"
      //   }
      // }
      switch (this.statusCode) {
        case -1:
          //未注册 当前状态只能操作register
          break
        case 0:
          //注册中 register
          break
        case 1:
          //离线  当前只能上线 logIn, applyForOffSite, forceToPrepareSignIn
          break
        case 2:
          //小休 置空闲，仅外呼，下线 ready, applyForCallOnly, changeVisibility,logOut
          break
        case 3:
          // 空闲  下线、外呼、接听，发起监听，会议 logOut, agentToAgent, call, monitor, applyForBreak, applyForCallOnly, bargeIn, intercept, coach, startConference
          break
        case 4:
          // 仅外呼 下线、外呼、接听、发起监听、会议、置空闲 logOut, agentToAgent, call, monitor, applyForBreak, changeVisibility, ready，bargeIn, intercept, coach, startConference
          break
        case 5:
          // 话后处理 置空闲 logOut, applyForBreak, ready, call, launchShortMessageAppraise, applyForCallOnly, applyForOffSite
          break
        case 6:
          //振铃 当前状态可接听 answer
          break
        case 7:
          // IM正在工作中
          break
        case 8:
          //拨号 挂断 hangUp, sendDtmf
          break
        case 9:
          //呼入通话 挂断 hangUp, callHold, callRetrieve, sendDtmf, muteAgent, umMuteAgent, transferStatisfic, launchAuthentication, thirdCallTransfer, initiateAttendedTransfer
          break
        case 10:
          // 呼出通话 挂断 hangUp, callHold, callRetrieve, sendDtmf, muteAgent, umMuteAgent, transferStatisfic, launchAuthentication, thirdCallTransfer, initiateAttendedTransfer
          break
        case 11:
          //内部通话 结束通话 hangUp, callHold, callRetrieve, sendDtmf, muteAgent, umMuteAgent
          break
        case 12:
          //通话保持 取消通话保持 callRetrieve
          break
        case 16:
          //发起三方 通话取回、取消三方通话 thirdCallRetrieve
          break
        case 17:
          //咨询通话 取消咨询通话、咨询通话转移 thirdCallRetrieve, thirdCallTransferFinished, sendDtmf, switchToConference
          break
        case 19:
          //会议 坐席由空闲状态发起会议 hangUp, sendDtmf
          break
        case 20:
          //被动求助 挂断 hangUp
          break
        case 21:
          // 监听 挂断 hangUp
          console.log('monitoring', detail)
          break
        case 24:
          //发起监听，还未监听成功
          console.log('Initiate monitoring', detail?.userContext)
          this.pushCallRecordMonitorLog(detail?.userContext)
          break
        case 25:
          //强插，进入三方通话 挂断 hangUp
          console.log('Initiate monitoring', detail)
          break
        case 26:
          //耳语坐席，进入三方通话 挂断 hangUp
          console.log('whisper', detail)
          break
        case 30:
          //会议中坐席状态变化 例如有人退出会议，或者有人进入会议 hangUp, transferStatisfic
          break

      }
    },
    /**
     * 推送话务记录
     */
    pushCallRecord: function (data) {
      let that = this
      this.$axios.post(that.$apis.HLConfigApi.callRecord.pushCallRecord, data, {
        baseURL: this.baseURL
      }).then(res => {
        if (res.success) {
          that.currentCallRecord = res.result || {}
          // 此处不显示台账信息 知道接通之后显示
          // this.currentLedgerId = that.currentCallRecord.ledgerId
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error("提交话务信息失败！")
      })
    },
    // 创建监听记录
    pushCallRecordMonitorLog: function (data) {
      // data = {
      //   "breakCode": "Warm-up",
      //   "deviceId": "CCC-192.168.31.130-chrome124-bs0aad18f2259e809",
      //   "extension": "80507050",
      //   "heartbeat": 1714268422254,
      //   "instanceId": "demo-1948805356977487",
      //   "jobId": "job-cff9ff67-9574-44fc-b469-561824368c8b",
      //   "mobile": "13900000001",
      //   "outboundScenario": false,
      //   "reserved": 1714268421969,
      //   "reservedTime": 1714268421969,
      //   "signedSkillGroupIdList": [
      //     "skg-default@demo-1948805356977487"
      //   ],
      //   "userId": "332518358@qq.com@demo-1948805356977487",
      //   "userState": "TALKING",
      //   "userStateTime": 1714268422254,
      //   "waitingForBreak": false,
      //   "waitingForBreakTime": 0,
      //   "workMode": "ON_SITE"
      // }
      let that = this
      let monitorLog = {
        appId: data?.instanceId || that.opts.appId,
        serialNum: data?.jobId,
        deviceId: data?.deviceId,
        userId: data?.userId
      }
      that.$axios.post(that.$apis.HLConfigApi.callRecord.pushCallRecordMonitorLog, monitorLog, {
        baseURL: this.baseURL
      }).then(res => {
        if (res.success) {
        } else {
          that.$Message.error({
            content: res.message || '创建监听记录失败！',
            duration: 3
          })
        }
      }).catch(function (err) {
        console.log('that error', err)
        that.$Message.error({
          content: '创建监听记录失败！',
          duration: 3
        })
      })
    },
    /**
     * 创建台账
     */
    popLedger: function (ledger) {
      let that = this
      that.$axios.post(that.$apis.ICHLApi.hotlineApi.popLedger, ledger).then(res => {
        if (res.success) {
          that.ledgerForm = res.result || {}
        } else {
          that.$Message.error({
            content: res.message || '台账生成失败！',
            duration: 3
          })
        }
      }).catch(function (err) {
        console.log('popLedger error', err)
      })
    },
    /**
     * 获取话务记录
     */
    loadCallRecord: function (appId, serialNum) {
      let that = this
      that.currentCallRecord = null
      that.conversationInfos = []
      that.keywords = []
      let params = new this.$URLSearchParams()
      params.append("appId", appId)
      params.append("serialNum", serialNum)
      that.$axios.post(that.$apis.HLConfigApi.callRecord.loadCallRecord, params, {
        baseURL: this.baseURL
      }).then(res => {
        if (res.success) {
          that.currentCallRecord = res.result || {}
          that.currentLedgerId = that.currentCallRecord.ledgerId
          that.$refs.workbenchDetail.show()
        } else {
          that.$Message.error({
            content: res.message || '获取话务记录失败！',
            duration: 3
          })
        }
      }).catch(function (err) {
        console.log('that error', err)
        that.$Message.error({
          content: '获取话务记录失败！',
          duration: 3
        })
      })
    },
    updateCallRecord: function (appId, serialNum, callRecordStatus) {
      let that = this
      let params = new this.$URLSearchParams()
      params.append("appId", appId)
      params.append("serialNum", serialNum)
      params.append("callRecordStatus", callRecordStatus)
      that.$axios.post(that.$apis.HLConfigApi.callRecord.updateCallRecord, params, {
        baseURL: this.baseURL
      }).then(res => {
        if (res.success) {
          that.currentCallRecord = res.result || {}
          that.currentLedgerId = that.currentCallRecord.ledgerId
          that.$refs.workbenchDetail.show()
          //5秒执行一次获取接口
          if (that.timerMessage) clearInterval(that.timerMessage)
          that.timerMessage = setInterval(() => {
            that.$refs.workbenchDetail.callConversationInfo()
          }, 5000)
        } else {
          that.$Message.error({
            content: res.message || '获取话务记录失败！',
            duration: 3
          })
        }
      }).catch(function (err) {
        console.log('that error', err)
        that.$Message.error({
          content: '获取话务记录失败！',
          duration: 3
        })
      })
    },
    /**
     * 挂断电话
     */
    hangUpRecord: function (type) {
      let that = this
      if (this.currentCallRecord?.appId && this.currentCallRecord?.serialNum) {
        let params = new this.$URLSearchParams()
        params.append("appId", this.currentCallRecord.appId)
        params.append("serialNum", this.currentCallRecord.serialNum)
        params.append("hangUpType", type)
        that.$axios.post(that.$apis.HLConfigApi.callRecord.hangUpRecord, params, {
          baseURL: this.baseURL
        }).then(res => {
          if (res.success) {
            that.currentCallRecord = res.result || {}
            that.currentLedgerId = that.currentCallRecord.ledgerId
            that.$refs.workbenchDetail.show()
          } else {
            that.$Message.error({
              content: res.message || '推送挂断失败！',
              duration: 3
            })
          }
        }).catch(function (err) {
          console.log('that error', err)
          that.$Message.error({
            content: '推送挂断失败！',
            duration: 3
          })
        }).finally(() => {
          if (that.timerMessage) clearInterval(that.timerMessage)
          that.timerMessage = null
        })
      }
    },
    hlFPDestroy: function () {
      console.log('workBench destroy')
      if (window.workbench) {
        // this.logOut()
        window.workbench.unloadWorkbench()
      }
      window.workbench = null
      // alert("workbench beforeDestroy")
      this.$emit('changeVisible', false)
    }
  },
  beforeMount () {
    let that = this
    this.$bus.$on('hlFPDestroy', () => {
      that.hlFPDestroy()
    })
    this.$nextTick(() => {
      that.initWorkbench()
    })
    // this.getActiveConfig()
  },
  destroyed () {
    console.log('workbench beforeDestroy')
    this.hlFPDestroy()
    // window.workbench.unloadWorkbench

    // window.workbench.reRender()
  }
}
</script>
